/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
export var CountryCode;
(function (CountryCode) {
    CountryCode["DE"] = "DE";
    CountryCode["DK"] = "DK";
    CountryCode["NO"] = "NO";
    CountryCode["SE"] = "SE";
})(CountryCode || (CountryCode = {}));
export var IssueMethod;
(function (IssueMethod) {
    IssueMethod["ACTIVATION_REQUEST"] = "ACTIVATION_REQUEST";
    IssueMethod["CODE"] = "CODE";
    IssueMethod["EMAIL"] = "EMAIL";
    IssueMethod["EMAIL_SMS"] = "EMAIL_SMS";
})(IssueMethod || (IssueMethod = {}));
export var Loa;
(function (Loa) {
    Loa["MAX"] = "MAX";
    Loa["ONE"] = "ONE";
    Loa["THREE"] = "THREE";
    Loa["TWO"] = "TWO";
    Loa["ZERO"] = "ZERO";
})(Loa || (Loa = {}));
export var OrganizationRole;
(function (OrganizationRole) {
    OrganizationRole["ADMIN"] = "ADMIN";
    OrganizationRole["ISSUER"] = "ISSUER";
    OrganizationRole["USER"] = "USER";
})(OrganizationRole || (OrganizationRole = {}));
export var AccessTokenType;
(function (AccessTokenType) {
    AccessTokenType["JWT"] = "JWT";
    AccessTokenType["REFERENCE"] = "REFERENCE";
})(AccessTokenType || (AccessTokenType = {}));
export var TokenExpiration;
(function (TokenExpiration) {
    TokenExpiration["SLIDING"] = "SLIDING";
    TokenExpiration["ABSOLUTE"] = "ABSOLUTE";
})(TokenExpiration || (TokenExpiration = {}));
export var TokenUsage;
(function (TokenUsage) {
    TokenUsage["RE_USE"] = "RE_USE";
    TokenUsage["ONE_TIME_ONLY"] = "ONE_TIME_ONLY";
})(TokenUsage || (TokenUsage = {}));
export var GroupMemberRole;
(function (GroupMemberRole) {
    GroupMemberRole["ADMIN"] = "ADMIN";
    GroupMemberRole["ISSUER"] = "ISSUER";
    GroupMemberRole["USER"] = "USER";
})(GroupMemberRole || (GroupMemberRole = {}));
export var AddressType;
(function (AddressType) {
    AddressType["HOME"] = "HOME";
    AddressType["OTHER"] = "OTHER";
    AddressType["OFFICIAL"] = "OFFICIAL";
})(AddressType || (AddressType = {}));
export var AuditLogActivity;
(function (AuditLogActivity) {
    AuditLogActivity["USER_IMPORTED"] = "USER_IMPORTED";
    AuditLogActivity["USER_AUTO_CREATED"] = "USER_AUTO_CREATED";
    AuditLogActivity["USER_CREATED_BY_ADMIN"] = "USER_CREATED_BY_ADMIN";
    AuditLogActivity["PASSWORD_SET"] = "PASSWORD_SET";
    AuditLogActivity["PASSWORD_CHANGED"] = "PASSWORD_CHANGED";
    AuditLogActivity["EXTERNAL_LOGIN_REMOVED"] = "EXTERNAL_LOGIN_REMOVED";
    AuditLogActivity["EXTERNAL_LOGIN_ADDED"] = "EXTERNAL_LOGIN_ADDED";
    AuditLogActivity["EMAIL_CONFIRMED"] = "EMAIL_CONFIRMED";
    AuditLogActivity["EMAIL_UPDATED"] = "EMAIL_UPDATED";
    AuditLogActivity["USERNAME_REQUESTED"] = "USERNAME_REQUESTED";
    AuditLogActivity["PASSWORD_RESET_REQUESTED"] = "PASSWORD_RESET_REQUESTED";
    AuditLogActivity["PHONE_NUMBER_ADDED"] = "PHONE_NUMBER_ADDED";
    AuditLogActivity["PHONE_NUMBER_REMOVED"] = "PHONE_NUMBER_REMOVED";
    AuditLogActivity["UNSUCCESSFUL_U_2_F_LOGIN"] = "UNSUCCESSFUL_U_2_F_LOGIN";
    AuditLogActivity["USER_CREATED_VIA_API"] = "USER_CREATED_VIA_API";
    AuditLogActivity["PASSWORD_RESET"] = "PASSWORD_RESET";
    AuditLogActivity["SELF_REGISTRATION"] = "SELF_REGISTRATION";
    AuditLogActivity["EMAIL_REMOVED"] = "EMAIL_REMOVED";
    AuditLogActivity["EMAIL_ADDED"] = "EMAIL_ADDED";
    AuditLogActivity["DEVICE_ADDED"] = "DEVICE_ADDED";
    AuditLogActivity["DEVICE_REMOVED"] = "DEVICE_REMOVED";
    AuditLogActivity["I_CLOUD_TOKEN_ADDED"] = "I_CLOUD_TOKEN_ADDED";
    AuditLogActivity["I_CLOUD_TOKEN_REMOVED"] = "I_CLOUD_TOKEN_REMOVED";
    AuditLogActivity["RELATION_ADDED"] = "RELATION_ADDED";
    AuditLogActivity["USER_CREATED"] = "USER_CREATED";
    AuditLogActivity["USER_UPDATED"] = "USER_UPDATED";
    AuditLogActivity["RELATION_REMOVED"] = "RELATION_REMOVED";
    AuditLogActivity["UNLOCKED"] = "UNLOCKED";
    AuditLogActivity["ACTIVATED"] = "ACTIVATED";
    AuditLogActivity["SET_PRIMARY_EMAIL"] = "SET_PRIMARY_EMAIL";
    AuditLogActivity["ACCOUNTS_MERGED"] = "ACCOUNTS_MERGED";
    AuditLogActivity["BIOMETRIC_KEY_ADDED"] = "BIOMETRIC_KEY_ADDED";
    AuditLogActivity["BIOMETRIC_KEY_REMOVED"] = "BIOMETRIC_KEY_REMOVED";
    AuditLogActivity["BLOCKED"] = "BLOCKED";
    AuditLogActivity["ISSUED"] = "ISSUED";
    AuditLogActivity["SIGN_IN_TICKET_CREATED"] = "SIGN_IN_TICKET_CREATED";
    AuditLogActivity["ADDRESS_ADDED"] = "ADDRESS_ADDED";
    AuditLogActivity["ADDRESS_REMOVED"] = "ADDRESS_REMOVED";
    AuditLogActivity["USER_DELETED"] = "USER_DELETED";
    AuditLogActivity["AUTHENTICATOR_ADDED"] = "AUTHENTICATOR_ADDED";
    AuditLogActivity["AUTHENTICATOR_REMOVED"] = "AUTHENTICATOR_REMOVED";
    AuditLogActivity["CREDENTIALS_REVOKED"] = "CREDENTIALS_REVOKED";
    AuditLogActivity["FIDO_AUTHENTICATOR_ADDED"] = "FIDO_AUTHENTICATOR_ADDED";
    AuditLogActivity["FIDO_AUTHENTICATOR_REMOVED"] = "FIDO_AUTHENTICATOR_REMOVED";
    AuditLogActivity["CLIENT_CERTIFICATE_ADDED"] = "CLIENT_CERTIFICATE_ADDED";
    AuditLogActivity["CLIENT_CERTIFICATE_REMOVED"] = "CLIENT_CERTIFICATE_REMOVED";
})(AuditLogActivity || (AuditLogActivity = {}));
export var EmailUse;
(function (EmailUse) {
    EmailUse["PRIVATE"] = "PRIVATE";
    EmailUse["PROFESSIONAL"] = "PROFESSIONAL";
    EmailUse["SKOLID_INTERNAL"] = "SKOLID_INTERNAL";
})(EmailUse || (EmailUse = {}));
export var UserRelationRole;
(function (UserRelationRole) {
    UserRelationRole["PARENT"] = "PARENT";
    UserRelationRole["CHILD"] = "CHILD";
    UserRelationRole["GENERIC"] = "GENERIC";
    UserRelationRole["PARTNER"] = "PARTNER";
})(UserRelationRole || (UserRelationRole = {}));
export var PhoneNumberUse;
(function (PhoneNumberUse) {
    PhoneNumberUse["PRIVATE"] = "PRIVATE";
    PhoneNumberUse["PROFESSIONAL"] = "PROFESSIONAL";
    PhoneNumberUse["ONLY_SMS_CODES"] = "ONLY_SMS_CODES";
})(PhoneNumberUse || (PhoneNumberUse = {}));
export var ClientSamlCertificateUse;
(function (ClientSamlCertificateUse) {
    ClientSamlCertificateUse["ANY"] = "ANY";
    ClientSamlCertificateUse["ENCRYPTION"] = "ENCRYPTION";
    ClientSamlCertificateUse["SIGNATURE"] = "SIGNATURE";
})(ClientSamlCertificateUse || (ClientSamlCertificateUse = {}));
export var SamlClientMappingRuleType;
(function (SamlClientMappingRuleType) {
    SamlClientMappingRuleType["CONSTANT"] = "CONSTANT";
    SamlClientMappingRuleType["RENAME"] = "RENAME";
    SamlClientMappingRuleType["CLEAR"] = "CLEAR";
    SamlClientMappingRuleType["COPY"] = "COPY";
})(SamlClientMappingRuleType || (SamlClientMappingRuleType = {}));
export var UserMergeMessageSeverity;
(function (UserMergeMessageSeverity) {
    UserMergeMessageSeverity["ERROR"] = "ERROR";
    UserMergeMessageSeverity["WARNING"] = "WARNING";
})(UserMergeMessageSeverity || (UserMergeMessageSeverity = {}));
export var ImportUserAction;
(function (ImportUserAction) {
    ImportUserAction["NOT_MODIFIED"] = "NOT_MODIFIED";
    ImportUserAction["UPDATE"] = "UPDATE";
    ImportUserAction["CREATE"] = "CREATE";
    ImportUserAction["ERROR"] = "ERROR";
    ImportUserAction["IGNORED"] = "IGNORED";
})(ImportUserAction || (ImportUserAction = {}));
export var ImportUserFieldStatus;
(function (ImportUserFieldStatus) {
    ImportUserFieldStatus["VALID"] = "VALID";
    ImportUserFieldStatus["INVALID"] = "INVALID";
    ImportUserFieldStatus["MISSING"] = "MISSING";
    ImportUserFieldStatus["CONFLICT"] = "CONFLICT";
})(ImportUserFieldStatus || (ImportUserFieldStatus = {}));
export var ImportUserPasswordFieldStatus;
(function (ImportUserPasswordFieldStatus) {
    ImportUserPasswordFieldStatus["NO_IMPORT_PASSWORD"] = "NO_IMPORT_PASSWORD";
    ImportUserPasswordFieldStatus["PASSWORD_IMPORT_NOT_ALLOWED"] = "PASSWORD_IMPORT_NOT_ALLOWED";
    ImportUserPasswordFieldStatus["BAD_PASSWORD"] = "BAD_PASSWORD";
    ImportUserPasswordFieldStatus["VALID"] = "VALID";
})(ImportUserPasswordFieldStatus || (ImportUserPasswordFieldStatus = {}));
//# sourceMappingURL=admin-gql.js.map